import styled from "@emotion/styled";

export const FullTimelineContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const TicksContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 2; // Add z-index to ensure it stays on top
  display: flex;
  width: 100%;
`;

export const TimelineWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  padding: 0px 0px;
`;

export const TracksContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
  position: relative;
`;

export const TrackWrapper = styled.div`
  position: relative;
  min-width: 100%;

  @media (min-width: 640px) {
    width: 83.333333%;
  }
`;
